import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueLazyloadNext from 'vue-lazyload-next'

// Global componenets
import ResetAction from './components/ui/ResetAction.vue'
import BackAction from './components/ui/BackAction.vue'

createApp(App)
.component('reset-action', ResetAction)
.component('back-action', BackAction)
.use(router)
.use(VueLazyloadNext)
.mount('#app');
